export enum cookies {
  VIEW_TYPE = 'ddSearchViewPreferenceV2',
}
